import { Component, Input, OnInit } from "@angular/core"
import { Observable } from "rxjs"
import { NgClass } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { Address, AddressFactory } from "src/app/models"

@Component({
    selector: "valben-address-input",
    templateUrl: "./address-input.component.html",
    standalone: true,
    imports: [NgClass, FormsModule],
})
export class AddressInputComponent implements OnInit {
    @Input() key: string = ""
    @Input() itemObservable!: () => Observable<any> | undefined
    @Input() update!: (value: any) => void
    @Input() title: string = ""
    @Input() error: boolean = false
    @Input() label: string = ''
    @Input() preview: boolean = false

    isNumberOrEmpty: boolean = true

    currentValue: Address = AddressFactory.create()

    ngOnInit(): void {
        this.itemObservable()?.subscribe((value: any) => {
            if (value !== null && value[this.key] !== this.currentValue) {
                this.currentValue = value[this.key]
            }
        })
    }

    onlyNumbers(event: Event): void {
        const el = event.target as HTMLInputElement
        if (isNaN(Number(el.value))) {
            this.isNumberOrEmpty = el.value === ""
        } else {
            this.isNumberOrEmpty = true
            this.currentValue.postalCode = Number(el.value)
        }
    }
}
